import { render, staticRenderFns } from "./InsuranceCompanyDisplayView.vue?vue&type=template&id=0175815a"
import script from "./InsuranceCompanyDisplayView.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports